import React, { Fragment } from "react";
import _ from "lodash";
import { connect } from "formik";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import LateralField from "./LateralField";

const SideLabelRadioButtonGroup = ({ label, fieldName, placeholder, formik, isDisabled, setFieldValue, options, children, ...otherProps }) => {
  const handleChange = event => {
    setFieldValue(fieldName, event.target.value.toString());
  };

  const val = _.get(formik.values, fieldName);

  return (
    <>
      <LateralField label={label}>
        <RadioGroup aria-label={label} name={label} value={val !== undefined && val !== null ? val.toString() : null} onChange={handleChange} row {...otherProps}>
          {
            options.map(option => (<FormControlLabel value={option.value.toString()} control={<Radio />} label={option.name} disabled={isDisabled} />))
          }
        </RadioGroup>
      </LateralField>
      {children}
    </>
  );
};
export default connect(SideLabelRadioButtonGroup);
